import { Component } from 'react'
import {
  SafeAreaView,
  Text,
  View,
  ScrollView,
  StyleSheet,
  Image,
  ImageBackground,
  TouchableOpacity,
  TouchableWithoutFeedback,
  Modal,
  Alert,
  Dimensions,
  SectionList,
  Platform,
} from 'react-native'

import DefaultNavigationOptions from '$navigation/_components/DefaultNavigationOptions.js'

class UpdatePhoneNumber extends Component {
  // ========================== header ==========================
  static navigationOptions = ({ navigation }) => {
    const options = DefaultNavigationOptions({
      navigation,
      hasCloseButton: true,
      closeButtonType: 'back',
    })

    return options
  }

  // ========================== end of header ==========================

  render() {
    return (
      <SafeAreaView>
        <Text>Update Phone Number</Text>
      </SafeAreaView>
    )
  }
}

export default UpdatePhoneNumber
